import {consentCookieValues, cookieExpiresAfter} from "../constants/cookieConstants";

const getOptionalConsentCookieValue = () => {
  const allCookies = document.cookie.split(";");
  const consentCookie = allCookies.filter(x => x.includes(consentCookieValues.OPTIONAL));
  if (!consentCookie?.length)
    return null;
  return consentCookie[0].split("=")[1];
}

const setOptionalConsentCookie = (value) => {
    const urlPath = `${consentCookieValues.OPTIONAL}=${value};expires=${cookieExpiresAfter()};path=/`;

    const isLocalhost = window.location.hostname === 'localhost';
    document.cookie = isLocalhost ? urlPath : `${urlPath};domain=.myworknest.com`;
}

export {
  getOptionalConsentCookieValue,
  setOptionalConsentCookie,
}